import React from 'react';
import {Link, useLocation} from "react-router-dom";
import SiteSearch from './search';
import * as yup from "yup";
import {useState, useEffect} from 'react';
import AffectedBookingsDialog from './affectedBookings';
import RevenueReport from './revenueReport';
import {useUserContext} from '../../contexts/user-context';
import GQLChanges from '../../utils/graphql-changes';
import {ModuleHistoryContext, useRecordModuleHistory} from '../../contexts/module-history-context';
import {fieldMappings} from './fieldMappings';
import {
    CampaignsQueryDocument,
    Site, SitesQueryDocument,
    useCreateSiteMutationMutation,
    useGetAffectedBookingsMutation,
    useSitesMutationMutation,
    useUpdateSiteMutationMutation
} from '../../generated/graphql';
import PlanningReport from './planningReport';
import {Button, Card} from "@mui/material";
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";
import {Download} from "@mui/icons-material";
import {useSnackbar} from "notistack";
import {SideList} from "../../components/SideList";
import {CostsReport} from "../campaigns/costreport";
import StatusReport from './statusReport';
import HSREPORT from './h&sReport';
import MainExportReport from './mainExportReport';

function convertVariables(initialValues, values) {
    const changes = new GQLChanges(fieldMappings);
    const ret = changes.compare(initialValues, values);
    return {input: ret};
    /*    graphqlSetLookups(['region', 'regionType', 'role', 'posterSize', 'ourContact', 'distributor', 'clientType', 'clientSubType', 'salesTeams', 'salesTeam', 'clientCompany', 'clientCompanyContact', 'sundryType', 'experientialType', 'ambientType', 'site', 'sitePricing', 'postInstruction', 'pack',
            'siteStructure', 'siteStructureType', 'healthAndSafetyType', 'buildContractor','buildType', 'planningStage', 'planningOutcome',
            'rentalType', 'paymentMethod', 'paymentFrequency','subletter','borough','style','tvArea']);
        return { input: graphqlObjectToInput(initialValues, values) };*/
}

function blankValues() {
    return {
        name: '',
        panels: [],
        latitude: '',
        longitude: '',
        siteStructure: null,
        siteBuildAndRepairs: [],
        siteRentals: [],
        sitePlannings: [],
        siteHealthAndSafeties: [],
        siteFilesOther: [],
        tags: [],
        tvArea: null
    };
}


const schema = yup.object().shape({
    name: yup.string().min(1),
    siteStructure: yup.object().required(),
    siteStructureType: yup.object().required(),
    sitePricing: yup.object().required(),
    region: yup.object().required(),
    distributor: yup.object().required(),
    subletter: yup.object().required()
});
const lookupColumns = ['region', 'region.regionType', 'posterSize', 'distributor',
    'sitePricing', 'panels.postInstruction', 'panels.pack',
    'siteStructure', 'siteStructureType', 'siteHealthAndSafeties.healthAndSafetyType',
    'sitePlannings.planningStage', 'sitePlannings.planningOutcome',
    'siteBuildAndRepairs.buildContractor', 'siteBuildAndRepairs.buildType', 'siteBuildAndRepairs.planningStage', 'siteBuildAndRepairs.planningOutcome',
    'siteRentals.rentalType', 'siteRentals.paymentMethod', 'siteRentals.paymentFrequency', 'subletter', 'borough', 'style', 'tvArea', 'tags'];


const modes = [
    {name: 'default', icon: 'list'},
    {
        name: 'image', icon: 'grid-view',
        // eslint-disable-next-line react/display-name
        render: function (values, callback) {
            return <div className="grid-view">{values.map((row) => {
                return <Link key={'img-' + row.id} to={{
                    pathname: '/sites/' + (row.id),
                    search: (location.search ? location.search : '')
                }}><Card onClick={callback}><img alt="" src={row.externalThumbnail}/><h3>{row.name}</h3></Card></Link>;
            })}</div>;
        }
    }
];

export function Sites() {
    const location = useLocation();
    const [affectedBookingsQuery] = useGetAffectedBookingsMutation();
//    useMutation(getAffectedBookings);
    const [affectedBookings, setAffectedBookings] = useState([]);
    const [ignoreAffected, setIgnoreAffected] = useState(false);
    const [showRevenueReport, setShowRevenueReport] = useState(false);
    const [showPlanningReport, setShowPlanningReport] = useState(false);
    const [showStatusReport, setShowStatusReport] = useState(false);
    const [showHSReport, setShowHSReport] = useState(false);
    const [showMainExportReport, setShowMainExportReport] = useState(false);
    const createMutation = useCreateSiteMutationMutation();
    //useMutation(createSiteMutation);
    const updateMutation = useUpdateSiteMutationMutation();
    //useMutation(updateSiteMutation);
    const combinedMutation = useSitesMutationMutation();
    const userContext = useUserContext();
    const user = userContext.user;
    const recordModuleHistory = useRecordModuleHistory();
    useEffect(() => {
        recordModuleHistory('sites');
    }, [recordModuleHistory, location]);

    const columns: FieldTableColumnProps<Site>[] = [
        {
            accessor: 'hide',
            header: '',
            dataType: 'excluder'
        },
        {
            accessor: 'name',
            header: 'Site Name',
            dataType: 'link',
            readOnly: true,
            options: {
                getLink:({field, row}) => {
                    return ({
                        pathname: '/sites/' + (row.id),
                        search: (location.search ? location.search : '')
                    });
                }
            }
        }, {
            accessor: 'region.name',
            header: 'Region',
            dataType: 'default'
        }, {
            header: 'Postcode',
            accessor: 'postcode',
            dataType: 'default'
        }, {
            header: 'Borough',
            accessor: 'borough.label',
            dataType: 'default',
        }, {
            accessor: 'numPanels',
            header: 'Num Panels',
            dataType: 'number'
        }, {
            accessor: 'site_code',
            header: 'Site Code',
            dataType: 'default'
        }, {
            accessor: 'siteStructure.name',
            header: 'Structure',
            dataType: 'default'
        }, {
            accessor: 'subletter.name',
            header: 'Sublet From',
            dataType: 'default'
        }, {
            accessor: 'rental',
            header: 'Rental',
            className: 'column-int',
            dataType: 'currency'
        }, {
            accessor: 'rates',
            header: 'Rates',
            className: 'column-int',
            dataType: 'currency'
        }, {
            accessor: 'rental_start',
            header: 'Rental Start',
            dataType: 'date'
        }, {
            accessor: 'rental_end',
            header: 'Rental End',
            dataType: 'date'
        }, {
            accessor: 'lat_lng',
            header: 'LatLng',
            dataType: 'default',
            options: {
                getValue: ({row}) => (row.latitude + ',' + row.longitude)
            },
            exportOnly: true,
        }, {
            accessor: 'three_words',
            header: 'What 3 Words',
            dataType: 'default',
            exportOnly: true
        }, {
            accessor: 'sitePricing.label',
            header: 'Price Rating',
            dataType: 'default',
            exportOnly:true
        }, {
            accessor: 'sitePricing.panel',
            header: 'Price Value',
            dataType: 'currency',
            exportOnly:true
        },
    ];
    const openRevenueReport = () => {
        setShowRevenueReport(true);
    };
    const closeRevenueReport = () => {
        setShowRevenueReport(false);
    };
    const openPlanningReport = () => {
        setShowPlanningReport(true);
    };
    const openStatusReport = () => {
        setShowStatusReport(true);
    };
    const closeStatusReport = () => {
        setShowStatusReport(false);
    };
    const openHSReport = () => {
        setShowHSReport(true);
    };
    const openMainExportReport = () => {
        setShowMainExportReport(true);
    };
    const closeHSReport = () => {
        setShowHSReport(false);
    };
    const closeMainExportReport = () => {
        setShowMainExportReport(false);
    };
    const closePlanningReport = () => {
        setShowPlanningReport(false);
    };
    const searchForm = (args) => {
        return <SiteSearch {...args} />;
    };

    return <SideList
        searchForm={searchForm}
        label="Sites"
        skipScroll={true}
        className="sites"
        permission="sites"
        deleteMutation={combinedMutation}
        simpleDelete={true}
        getResults={(e)=>e.sites}
        query={SitesQueryDocument}
        columns={columns}
        baseUrl="/sites/"
        extraContent={(values)=><><RevenueReport isOpen={showRevenueReport} values={values} doClose={closeRevenueReport}/>
        <PlanningReport isOpen={showPlanningReport} values={values} doClose={closePlanningReport}/>
        <StatusReport isOpen={showStatusReport} values={values} doClose={closeStatusReport}/>
        <HSREPORT isOpen={showHSReport} values={values} doClose={closeHSReport}/>
        <MainExportReport isOpen={showMainExportReport} values={values} doClose={closeMainExportReport}/>
        </>}
        footer={<><Button size="large" key="exportBtnAdv1" onClick={openRevenueReport} startIcon={<Download/>}>Revenue Report</Button>
            <Button size="large" key="exportBtnAdv2" onClick={openPlanningReport} startIcon={<Download/>}>Planning Report</Button>
            <Button size="large" key="exportBtnAdv2" onClick={openStatusReport} startIcon={<Download/>}>Status Report</Button>
            <Button size="large" key="exportBtnAdv2" onClick={openHSReport} startIcon={<Download/>}>Site Health Report</Button>
            <Button size="large" key="exportBtnAdv2" onClick={openMainExportReport} startIcon={<Download/>}>Main Export Report</Button>
        </>}
        modes={modes}
    />;

/*

    return (<SideEditorFull
        label="Site"
        searchForm={searchForm}
        className="sites"
        getResults={(e) => e.sites}
        query={sitesQuery}
        permission="sites"
        columns={columns}
        modes={modes}
        render={
            {}
        }
        baseUrl="/sites/"
        hasDelete={user.role.name == 'Admin Role'}
        combinedMutation={combinedMutation}
        footer={<><Button size="large" key="exportBtnAdv" onClick={openRevenueReport}><Download/>Revenue Report</Button>
            <Button size="large" key="exportBtnAdv" onClick={openPlanningReport}><Download/>Planning Report</Button>
        </>}
        extraContent={
            (values) => {
                //if(values.length) {
                 //   var numPanels = 0, numSites = 0;
                  //  values.forEach(row=>{
                   //     numSites++;
                  ///      numPanels+=row.numPanels;
                  //  })
                //}
                //numPanels && <span>{numPanels} panels returned over {numSites} sites</span>
                return (
                    <>
                        <RevenueReport isOpen={showRevenueReport} values={values} doClose={closeRevenueReport}/>
                                        <Dialog className="site__revenue-report__dialog" isOpen={showRevenueReport} onClose={closeRevenueReport} title="Revenue Report">
                {showRevenueReport&&<RevenueReport doClose={closeRevenueReport} values={values}/>}</Dialog>
                        <Dialog className="site__revenue-report__dialog" isOpen={showPlanningReport} onClose={closePlanningReport} title="Planning Report">
                {showPlanningReport&&<PlanningReport doClose={closePlanningReport} values={values}/>}</Dialog>
                    </>);
            }
        }
        editorProps={{
            className: 'site__editor',
            lookupColumns: lookupColumns,
            // eslint-disable-next-line react/display-name
            form: (args) => {
                const onAccept = () => {
                    setIgnoreAffected(true);
                    setAffectedBookings([]);
                    args.diaForm.handleSubmit();
                };
                const onCancel = () => {
                    setAffectedBookings([]);
                };
                return (<>
                    <SiteForm {...args} />
                    <AffectedBookingsDialog name={args.diaForm.values.name} isOpen={affectedBookings.length}
                                            affectedBookings={affectedBookings} onAccept={onAccept}
                                            onCancel={onCancel}/>
                </>);
            },
            createMutation: createMutation,
            updateMutation: updateMutation,
            getQuery: getSiteQuery,
            submitGuard: checkAvailabilities,
            getDataFromGraphql: (v) => {
                return v.site;
            },
            getIdFromResult: (v) => {
                return v.createSite.id;
            },
            convertVariables: convertVariables,
            validationSchema: schema,
            blankValues: blankValues
        }}
    />);*/
}


